<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.115 15.745">
  <path
    d="M13.856,0H1.261A1.26,1.26,0,0,0,0,1.26V5.668a10.017,10.017,0,0,0,3.694,8.045,11.017,11.017,0,0,0,3.7,2.01.642.642,0,0,0,.331,0,11.042,11.042,0,0,0,3.7-2.01,10.028,10.028,0,0,0,3.689-8.045V1.26A1.26,1.26,0,0,0,13.856,0Z"
    fill="currentColor" />
  <path
    d="M3.964,8a.63.63,0,0,1,.891-.891L6.3,8.557l3.963-3.964a.63.63,0,1,1,.892.891L6.744,9.893a.63.63,0,0,1-.891,0h0Z"
    fill="#fff" />
</svg>